module.exports = __webpack_public_path__ + "img/eye-closed.d035c7ed.svg";